export const classBuilderI18n = {
  en: {
    back: 'Back',
    scheduleHours: 'Schedule Hours',
    startHour: 'Start Hour',
    endHour: 'End Hour',
    scheduleHoursDisclamer: 'Please specify the hours you desire for the school schedule.',
    conflictsHours: 'The start hour must be before the end hour.',
    days: 'Days',
    addBlockConflictsHour: 'This time or days has conflicts with others blocks. Please verify.',
    addTime: 'Add Time',
    addQuickAddSubject: 'Add Subject',
    quickAddSubject: 'Subject',
    teacher: 'Teacher',
    creatingQuickAddSubject: 'Creating Subject',
    selectScheduleType: 'Please select the schedule type:',
    selectShortDay: 'Please select the day of the week this short day will apply:',
    selectDayPlaceholder: 'Select a day',
    addShortDay: 'Add Short Day',
    ab: 'A/B',
    weekly: 'Weekly',
    shortDay: 'Short Day',
    errorSavingScheduleType: 'There was an error saving the schedule type. Please try again.',
    errorSavingShortDay: 'There was an error saving the short day. Please try again.',
    AS: 'A Short',
    BS: 'B Short',
    A: 'A',
    B: 'B',
  },
  es: {
    back: 'Atrás',
    scheduleHours: 'Horario de Clases',
    startHour: 'Hora de Inicio',
    endHour: 'Hora de Fin',
    scheduleHoursDisclamer: 'Por favor, especifique las horas que desea para el horario escolar.',
    conflictsHours: 'La hora de inicio debe ser antes de la hora de finalización.',
    days: 'Días',
    addBlockConflictsHour: 'Esta hora o días tiene conflictos con otros bloques. Por favor, verifique.',
    addTime: 'Agregar Horario',
    addQuickAddSubject: 'Agregar',
    quickAddSubject: 'Materia',
    teacher: 'Profesor',
    creatingQuickAddSubject: 'Creando Materia',
    selectScheduleType: 'Por favor selecciona el tipo de horario:',
    selectShortDay: 'Por favor selecciona el día de la semana al que se aplicará este día corto:',
    selectDayPlaceholder: 'Selecciona un día',
    addShortDay: 'Agregar Día Corto',
    ab: 'A/B',
    weekly: 'Semanal',
    shortDay: 'Día Corto',
    errorSavingScheduleType: 'Hubo un error al guardar el tipo de horario. Por favor, inténtalo de nuevo.',
    errorSavingShortDay: 'Hubo un error al guardar el día corto. Por favor, inténtalo de nuevo.',
    AS: 'A Corto',
    BS: 'B Corto',
    A: 'A',
    B: 'B',
  }
}
